import {gql} from "@irati/utils/gql"

const fragment = gql`
  fragment unAuthedUser on UnauthedUser {
    uuid
    businessId
    email
    firstName
    lastName
    language
  }
`

export const toString = fragment.loc.source.body

export default fragment
